import {
    Component,
    OnInit,
    ViewEncapsulation,
    Input,
    Output,
    EventEmitter
} from '@angular/core';
import { Helpers } from '../../../../../../helpers';
import { BaseComponent } from '../../../base.component';
import { Reservation } from '../../../../../../models/reservation';
import { DataService } from '../../../../../../_services/data.service';
import { ReservationService } from '../../../../../../services/reservation.service';
import { AdUnitService } from '../../../../../../services/adunit.service';
import {
    SelectService,
    SelectEvent,
    SelectedOption
} from '../../../../../../_services/select.service';
import { ReservationDetail } from '../../../../../../models/reservation-detail';
import { ReservationDetailDate } from '../../../../../../models/reservation-detail-date';
import { ReservationCity } from '../../../../../../models/reservation-city';
import { Customer } from '../../../../../../models/customer';
import { Agency } from '../../../../../../models/agency';
import { LoadingService } from '../../../../../../_services/loading.service';
import {
    DatepickerService,
    DatepickerEvent
} from '../../../../../../_services/datepicker.service';
import { ApiError } from '../../../../../../models/api-error';

@Component({
    selector: 'app-reservation-update',
    templateUrl: './reservation-update.component.html',
    encapsulation: ViewEncapsulation.None
})
export class ReservationUpdateComponent extends BaseComponent
    implements OnInit {
    model: Reservation = new Reservation();
    customer: Customer = new Customer();
    agency: Agency = new Agency();
    adUnits: any[] = [];
    selectedAdUnits: any[] = [];
    selectedSiteId: any;
    filteredAdUnits: any[] = [];
    updateSearchTargetKey: string = '';
    closedDates: any[] = [];
    datesDisabled: any[] = [];

    private _reservationId: string;
    get reservationId(): string {
        return this._reservationId;
    }
    @Input()
    set reservationId(reservationId: string) {
        this._reservationId = reservationId;
        if (this._reservationId) {
            this.getReservation(reservationId);
        }
    }
    @Output()
    closed = new EventEmitter<any>();

    constructor(
        private reservationService: ReservationService,
        private adUnitService: AdUnitService,
        private dataService: DataService,
        private selectService: SelectService,
        private datepickerService: DatepickerService,
        private loading: LoadingService
    ) {
        super();
        this.model.publisherId = this.dataService.publisherId;
    }
    ngOnInit() { }
    close() {
        this.closed.emit();
        this.clearUpdatePage();
    }
    getReservation(reservationId: string) {
        var self = this;
        this.model.id = reservationId;
        this.loading.show();
        this.reservationService.find(this.model.id).subscribe(res => {
            this.model = res.data;
            this.initSelect();
            this.initSelectedTargets();
        });
    }
    initSelectedTargets() {
        for (let i = 0; i < this.model.reservationDetails.length; i++) {
            var reservationDetail = this.model.reservationDetails[i];
            var adUnit = reservationDetail.adUnit;
            this.selectedAdUnits.push(adUnit);
            var dates = reservationDetail.reservationDetailDates.map(function(r) {
                return new Date(r.date);
            });
            adUnit['dateCount'] = dates.length;
            adUnit['dates'] = dates;
        }
        var self = this;
        (<any>$('#updateSelectedTargetScrollBar')).mCustomScrollbar({
            axis: 'yx',
            advanced: { autoExpandHorizontalScroll: true },
            mouseWheel: { scrollAmount: 50 }
        });
        for (let i = 0; i < this.selectedAdUnits.length; i++) {
            setTimeout(() => {
                var selectedAdUnit = this.selectedAdUnits[i];

                this.reservationService
                    .getReservationAdUnitClosedDates(selectedAdUnit.id)
                    .subscribe(res => {
                        self.closedDates = res.data.dates.map(x => new Date(x));
                        const adUnitId = res.data.adUnitId;
                        var selectedDates = selectedAdUnit.dates;
                        let datesDisabled = self.closedDates.filter(function(x) {
                            return (
                                selectedDates
                                    .map(y => y.toDateString())
                                    .indexOf(x.toDateString()) === -1
                            );
                        });
                        this.loadAdUnitDatePicker(selectedAdUnit, datesDisabled);

                        self.loading.hide();
                    });
            }, 1000);
        }
    }
    initSelect() {
        var self = this;
        var selectedCities: SelectedOption[] = [];
        for (let reservationCity of this.model.reservationCities) {
            selectedCities.push(
                new SelectedOption(reservationCity.city.id, reservationCity.city.name)
            );
        }
        this.selectService
            .init({
                url: '/sites/list?filterId=' + this.model.publisherId,
                controlId: 'updateSiteId',
                displayProperty: 'title'
            })
            .on(SelectEvent.select, function(e) {
                self.selectedSiteId = e.params.data.id;
                self.getTargets();
            });
        this.selectService
            .init({
                url: '/customers/list?filterId=' + this.model.publisherId,
                controlId: 'updateCustomerId',
                displayProperty: 'name',
                selectedOption: new SelectedOption(
                    self.model.customerId,
                    self.model.customer.name
                )
            })
            .on(SelectEvent.select, function(e) {
                self.model.customerId = e.params.data.id;
            });
        this.selectService
            .init({
                url: '/agencies/list?filterId=' + this.model.publisherId,
                controlId: 'updateAgencyId',
                displayProperty: 'name',
                selectedOption: new SelectedOption(
                    self.model.agencyId,
                    self.model.agency != null ? self.model.agency.name : ''
                )
            })
            .on(SelectEvent.select, function(e) {
                if (e.params.data.id != null)
                    self.model.agencyId = e.params.data.id;
            });
        this.selectService
            .init({
                url: '/cities/list',
                controlId: 'updateCityId',
                displayProperty: 'name',
                multiple: true,
                selectedOptions: selectedCities
            })
            .on(SelectEvent.select, function(e) { });
    }
    addAdUnit() {
        var text = document.getElementById('addButton').textContent;
        if (text == '+') {
            document.getElementById('addButton').textContent = '-';
        } else {
            document.getElementById('addButton').textContent = '+';
        }
    }
    onTargetSelect(adUnit) {
        adUnit.dateCount = 0;
        this.selectedAdUnits.push(adUnit);
        this.selectedAdUnits.sort(function(a, b) {
            var nameA = a.page.name + '/' + a.title;
            var nameB = b.page.name + '/' + b.title;
            if (nameA < nameB) {
                return -1;
            }
            if (nameA > nameB) {
                return 1;
            }
            return 0;
        });
        setTimeout(() => { }, 50);
        this.loadFilteredAdUnits();
    }
    updateSearchTarget(event) {
        this.updateSearchTargetKey = event.target.value.toLowerCase();
        this.loadFilteredAdUnits();
    }
    loadFilteredAdUnits() {
        var self = this;
        this.filteredAdUnits = this.adUnits.filter(function(a) {
            var selectedAdUnit = self.selectedAdUnits.filter(function(s) {
                return s.id == a.id;
            });
            return (
                selectedAdUnit.length == 0 &&
                (self.updateSearchTargetKey == '' ||
                    a.title.toLowerCase().includes(self.updateSearchTargetKey) ||
                    a.page.name.toLowerCase().includes(self.updateSearchTargetKey))
            );
        });
        this.filteredAdUnits.sort(function(a, b) {
            var nameA = a.page.name + '/' + a.title;
            var nameB = b.page.name + '/' + b.title;
            if (nameA < nameB) {
                return -1;
            }
            if (nameA > nameB) {
                return 1;
            }
            return 0;
        });
    }
    onClickDate(adUnit) {
        this.loading.show();
        this.reservationService
            .getReservationAdUnitClosedDates(adUnit.id)
            .subscribe(res => {
                this.closedDates = res.data.dates.map(x => new Date(x));
                this.InitAdUnitDatepicker(adUnit);
                this.loading.hide();
            });
    }
    InitAdUnitDatepicker(adUnit) {
        var self = this;
        var startDate = new Date(); //geçmiş tarihleri kaybetmemek için kapattık.
        var adUnitDatepicker = this.datepickerService.init(adUnit.id, {
            datesDisabled: this.closedDates,
            multiSelectWeek: true,
            multiSelectDays: true
            //startDate: startDate
        });
        adUnitDatepicker.onChangeDate(function() {
            var adUnitDates = self.datepickerService.getDates(adUnit.id);
            adUnit.dateCount = adUnitDates.length;
            if (adUnit.dateCount > 0)
                (<any>$('#badge' + adUnit.id)).addClass('m-badge--info');
            else (<any>$('#badge' + adUnit.id)).removeClass('m-badge--info');
        });
        adUnitDatepicker.onHide(function(event) {
            event.type = '';
        });
        // adUnitDatepicker.onShow(function() {});
        var type = (<any>$('#' + adUnit.id)).attr('type');
        if (type == 'focusin') {
            (<any>$('#' + adUnit.id)).trigger('blur');
            (<any>$('#' + adUnit.id)).attr('type', '');
        } else {
            (<any>$('.adUnitDatePicker')).attr('type', '');
            (<any>$('#' + adUnit.id)).trigger('focus');
            (<any>$('#' + adUnit.id)).attr('type', 'focusin');
        }
    }
    loadAdUnitDatePicker(adUnit, datesDisabled) {
        var self = this;
        //var startDate = new Date();  geçmiş tarihleri kaybetmemek için kapattık.
        var adUnitDatepickerUpdate = this.datepickerService.init(adUnit.id, {
            multiSelectWeek: true,
            multiSelectDays: true
            //startDate: startDate
        });
        adUnitDatepickerUpdate.onChangeDate(function() {
            var adUnitDates = self.datepickerService.getDates(adUnit.id);
            adUnit.dateCount = adUnitDates.length;
            if (adUnit.dateCount > 0)
                (<any>$('#badge' + adUnit.id)).addClass('m-badge--info');
            else (<any>$('#badge' + adUnit.id)).removeClass('m-badge--info');
        });
        adUnitDatepickerUpdate.onHide(function(event) {
            event.type = '';
        });
        adUnitDatepickerUpdate.onShow(function() { });

        this.datepickerService.setDatesDisabled(adUnit.id, datesDisabled);
        this.datepickerService.setDates(adUnit.id, adUnit.dates);
    }
    onSelectedTargetSelect(adUnit) {
        this.selectedAdUnits = this.selectedAdUnits.filter(function(obj) {
            return obj.id !== adUnit.id;
        });
        this.loadFilteredAdUnits();
    }
    getTargets() {
        var self = this;
        self.adUnits = [];
        this.loading.show();
        this.adUnitService.listBySiteId(this.selectedSiteId).subscribe(res => {
            this.loading.hide();
            self.adUnits = res.data;
            this.updateSearchTargetKey = '';
            this.loadFilteredAdUnits();
            (<any>$('#updateTargetScrollBar')).mCustomScrollbar({
                axis: 'yx',
                advanced: { autoExpandHorizontalScroll: true },
                mouseWheel: { scrollAmount: 50 }
            });
        });
    }
    updateReservation() {
        this.loading.show();
        this.model.publisherId = this.dataService.publisherId;
        this.model.reservationCities = [];
        this.model.reservationDetails = [];
        this.mapReservationDetails();
        this.mapReservationCities();

        this.reservationService.update(this.model).subscribe(res => {
            this.swalService.successUpdate();
            this.close();
            this.loading.hide();
        });
    }
    mapReservationCities() {
        this.model.reservationCities = [];
        var selectedCities = this.selectService.getSelectedValues('updateCityId');
        for (let i = 0; i < selectedCities.length; i++) {
            const city = selectedCities[i];
            var reservationCity = new ReservationCity();
            reservationCity.reservationId = this.model.id;
            reservationCity.cityId = city.id;
            this.model.reservationCities.push(reservationCity);
        }
    }
    mapReservationDetails() {
        this.model.reservationDetails = [];
        for (let i = 0; i < this.selectedAdUnits.length; i++) {
            const adUnit = this.selectedAdUnits[i];
            var reservationDetail = new ReservationDetail();
            reservationDetail.reservationId = this.model.id;
            reservationDetail.adUnitId = adUnit.id;
            var adUnitDates = this.datepickerService.getDates(adUnit.id);
            if (adUnitDates.length < 1) {
                var apiError = new Error();
                apiError.message =
                    'There is no date selected on this Target = ' +
                    adUnit.page.site.title +
                    '/' +
                    adUnit.page.name +
                    '/' +
                    adUnit.title +
                    '  ';
                apiError['showMessage'] = true;
                throw apiError;
            }
            reservationDetail.reservationDetailDates = [];
            for (let k = 0; k < adUnitDates.length; k++) {
                const date = adUnitDates[k];
                var reservationDetailDate = new ReservationDetailDate();
                reservationDetailDate.date = date;
                reservationDetail.reservationDetailDates.push(reservationDetailDate);
            }
            this.model.reservationDetails.push(reservationDetail);
        }
    }
    clearUpdatePage() {
        this.adUnits = [];
        this.selectedAdUnits = [];
        this.selectedSiteId = [];
        this.filteredAdUnits = [];
        this.updateSearchTargetKey = '';
        this.model = new Reservation();
        this.customer = new Customer();
        this.agency = new Agency();
        (<any>$('#updateCityId')).empty().trigger('change');
        (<any>$('#updateAgencyId')).empty().trigger('change');
        (<any>$('#updateCustomerId')).empty().trigger('change');
        (<any>$('#updateSiteId')).empty().trigger('change');
    }

    deleteReservation() {
        this.swalService.confirmDelete().then(res => {
            if (res.value) {
                this.loading.show();
                this.reservationService.delete(this.model.id).subscribe(() => {
                    this.swalService.successDelete();
                    this.close();
                    this.loading.hide();
                });
            }
        });
    }

    validate(event) {
        var customRules = this.validationService.customRules;
        return this.validationService.validate(event, {
            rules: {
                reservationName: customRules.requiredText,
                updateCustomerId: {
                    required: true
                }
            }
        });
    }
}



// WEBPACK FOOTER //
// /Users/creative/Documents/GitHub/makrooreservation/src/ui/src/app/theme/pages/default/publisher/reservation/reservation-update/reservation-update.component.ts